import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  copy(event) {
    const button = event.currentTarget
    const url = button.dataset.url
    const label = button.querySelector("[data-copy-links-target='label']")

    navigator.clipboard.writeText(url).then(() => {
      const originalText = label.textContent
      label.textContent = "Copied!"
      button.classList.add("btn-green")
      button.classList.remove("btn-white")

      setTimeout(() => {
        label.textContent = originalText
        button.classList.remove("btn-green")
        button.classList.add("btn-white")
      }, 1500)
    })
  }
}
